import { render, staticRenderFns } from "./Cedents.vue?vue&type=template&id=46dc6758&"
import script from "./Cedents.vue?vue&type=script&lang=js&"
export * from "./Cedents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports